<template>
    <div>
        <div class="row justify-content-center align-items-center">
            <div class="col-12 form-group">
                <label class="w-100 mb-0">
                    <div>{{$ml.get('card_number')}}</div>
                    <div ref="cardNumber"></div>
                </label>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-12">
                <div class="row justify-content-start align-items-center">
                    <div class="col-8 form-group">
                        <label class="w-100 mb-0">
                            <div>{{$ml.get('Expiration_Date')}}</div>
                            <div ref="cardExpiry"></div>
                        </label>
                    </div>
                    <div class="col-4 form-group">
                        <label class="w-100 mb-0">
                            <div>{{$ml.get('cvc')}}
                            </div>
                            <div ref="cardCvc"></div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-12 form-group">
                <label class="ml-2 text-uppercase mb-0" for="card_holder">{{$ml.get('card_holder')}}</label>
                <input type="text" class="form-control" id="card_holder" name="card_holder"
                       :placeholder="$ml.get('card_holder')"
                       v-model="card_holder"
                       v-validate="'required'"
                       :class="{'is-invalid': errors.has('card_holder')}">
            </div>
        </div>
    </div>
</template>

<script>
    let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY),
        elements = stripe.elements(),
        cardNumber = undefined,
        cardExpiry = undefined,
        cardCvc = undefined;

    export default {
        name: "PaymentOptions",
        data() {
            return {
                card_holder: '',
                errorMessages: {
                    card_holder: ''
                },
            }
        },
        mounted() {
            this.card_holder = `${this.$store.state.loggedUser.first_name} ${this.$store.state.loggedUser.last_name}`;
            const style = {
                base: {
                    fontSize: '16px',
                    color: '#002e42',
                    '::placeholder': {
                        color: '#B7B7B7'
                    }
                },
                invalid: {
                    color: '#dc3545',
                    borderColor: '#dc3545'
                }
            };
            const classes = {
                base: 'form-control qf-payment-input',
                focus: 'qf-payment-input-focus',
                invalid: 'is-invalid'
            };

            cardNumber = elements.create('cardNumber', {
                classes: classes, style: style
            });
            cardNumber.mount(this.$refs.cardNumber);
            cardExpiry = elements.create('cardExpiry', {
                classes: classes, style: style
            });
            cardExpiry.mount(this.$refs.cardExpiry);
            cardCvc = elements.create('cardCvc', {
                classes: classes, style: style
            });
            cardCvc.mount(this.$refs.cardCvc);
        },
        methods: {
            updatePaymentData() {
                debugger;
            }
        },
        beforeDestroy() {
            cardNumber.destroy();
            cardExpiry.destroy();
            cardCvc.destroy();
        }
    }
</script>

<style scoped>

</style>
